import { ICOSMOSSmartInfo, ICOSMOSResponseSuggestion, ICOSMOSResponseSolution } from './models';

/**
 * This function sorts topics and subtopics, saves total subtopics number and
 * adds order number to each subtopic.
 *
 * @function prepareDataForRender
 * @param  {ICOSMOSSmartInfo} data
 * @return {ICOSMOSSmartInfo}
 */
export default function prepareDataForRender(data : ICOSMOSSmartInfo) : ICOSMOSSmartInfo {
	data.suggestedTopics.sort(sortTopics);
	data.suggestedTopics.forEach(topic => topic.solutions.sort(sortSolutions));

	let total = 0;
	data.suggestedTopics.forEach(topic => total += topic.solutions ? topic.solutions.length : 0);
	data.total = total;

	let count = 0;
	data.suggestedTopics.forEach(topic => topic.solutions.forEach(solution => { count++; solution.solutionNo = count; }));

	return data;
}

/**
 * This function sorts elements based on the `topicId` property.
 *
 * @function sortTopics
 * @param  {ICOSMOSResponseSuggestion} a
 * @param  {ICOSMOSResponseSuggestion} b
 * @return {number} 0 if a.topicId is equal to b.topicId, 1 if a.topicId is
 * greater than b.topicId, otherwise -1
 */
export function sortTopics(a : ICOSMOSResponseSuggestion, b : ICOSMOSResponseSuggestion) : number {
	return parseInt(a.topicId, 10) - parseInt(b.topicId, 10);
}

/**
 * This function sorts elements based on the `urlId` property.
 *
 * @function sortSolutions
 * @param  {ICOSMOSResponseSolution} a
 * @param  {ICOSMOSResponseSolution} b
 * @return {number} 0 if a.urlId is equal to b.urlId, 1 if a.urlId is
 * greater than b.urlId, otherwise -1
 */
export function sortSolutions(a : ICOSMOSResponseSolution, b : ICOSMOSResponseSolution) : number {
	return parseInt(a.urlId, 10) - parseInt(b.urlId, 10);
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/cosmos/functions.ts